module.exports = __webpack_public_path__ + "static/media/space-card-hero-md@2x.87d6abd5.png";